import React from "react";
import {useCountertops} from "../contexts/countertopsContext";
import {Switch} from "devextreme-react/switch";

const spacer = <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>;

export function EstimateOptionsSelectorComponent() {
    const context = useCountertops();

    return (
        <>
            <div className={'dx-card content'} style={{padding: '10px'}}>
                <div style={{float: 'left'}}>
                    <span>This quote involves:</span>
                    {spacer}
                    <label>
                        <input type={"checkbox"} checked={true} disabled={true}/>
                        Countertop
                    </label>
                    {spacer}
                    <label>
                        <input type={"checkbox"} checked={true} disabled={true}/>
                        Edges
                    </label>
                    {spacer}
                    <label>
                        <input type={"checkbox"} checked={context.showSinks}
                               onChange={(event: React.ChangeEvent<HTMLInputElement>) => context.updateShowSinks(event.target.checked)}/>
                        Sinks
                    </label>
                    {spacer}
                    <label>
                        <input type={"checkbox"} checked={context.showCutouts}
                               onChange={(event: React.ChangeEvent<HTMLInputElement>) => context.updateShowCutouts(event.target.checked)}/>
                        Cutouts
                    </label>
                    {spacer}
                    <label>
                        <input type={"checkbox"} checked={context.showSafetyCorners}
                               onChange={(event: React.ChangeEvent<HTMLInputElement>) => context.updateShowSafetyCorners(event.target.checked)}/>
                        Safety Corners
                    </label>
                    {spacer}
                    <label>
                        <input type={"checkbox"} checked={context.showFinishingTouches}
                               onChange={(event: React.ChangeEvent<HTMLInputElement>) => context.updateShowFinishingTouches(event.target.checked)}/>
                        Finishing Touches
                    </label>
                    {spacer}
                </div>
                <div style={{lineHeight: 0}}>
                    <Switch onValueChanged={(e) => context.updateShowPrices(e.value)}></Switch>
                </div>
            </div>
        </>
    );
}